import { render, staticRenderFns } from "./FooterFix.vue?vue&type=template&id=479e0709"
import script from "./FooterFix.vue?vue&type=script&lang=js"
export * from "./FooterFix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports